import { render } from "./InstitutesView.vue?vue&type=template&id=bfbabb8e&scoped=true"
import script from "./InstitutesView.vue?vue&type=script&lang=js"
export * from "./InstitutesView.vue?vue&type=script&lang=js"

import "./InstitutesView.vue?vue&type=style&index=0&id=bfbabb8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbabb8e"]])

export default __exports__